<template>
  <v-container fluid pt-0>
    <v-row align="center" class="pb-2">
      <h1 class="headline">Commissions</h1>
      <v-spacer></v-spacer>
            <v-col class="py-0">
        <list-filters
          :filters="filters"
          label="Find commission"
          ref-name="commissions_list_filters"
          @searchParamsChanged="onFiltersChange"
          :expansionPanel="false"
        ></list-filters>
      </v-col>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" fab dark color="primary" @click="onCreateNew">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Create New Commission</span>
      </v-tooltip>
    </v-row>

    <v-row>
      <v-col class="pa-0">
        <v-data-table
          show-select
          v-model="selected"
          :headers="headers"
          :items="items"
          :loading="$apollo.loading"
          :search="search"
        >
        <template v-slot:item.notInUse="{ item }">
          <v-simple-checkbox
            v-model="item.notInUse"
            disabled
          ></v-simple-checkbox>
        </template>
          <template v-slot:item.agentGroupName="{ item }">
            <v-row align="center">
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="grey lighten-1" class="px-1" small
                    >mdi-information-outline</v-icon
                  >
                </template>
                <v-container>
                  {{
                    item.agentGroup && item.agentGroup.members.edges.length > 0
                      ? item.agentGroup.members.edges
                          .map((g) => g.node.name)
                          .join(", ")
                      : "No members."
                  }}
                </v-container>
              </v-tooltip>
              {{ item.agentGroupName }}
            </v-row>
          </template>
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              hide-view
              @deleteItem="onDeleteItem"
              @editItem="onEditItem"
            >
            </default-list-actions>
          </template>
          <template v-slot:footer>
            <list-actions
              v-if="selected.length > 0"
              :selected="selected"
              list="commissions"
              :columns="headers.map(c => c.name)"
              :filter="searchParams"
              @close="selected = []"
            >
            </list-actions>
        <v-row justify="center" v-if="selected.length > 0">
          <h3 class="py-2 caption">{{ selected.length }} record(s) selected</h3>
        </v-row>
      </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row v-if="debug">
      <code>{{}}</code>
    </v-row>
    <commission-edit-dialog
      :show="showCommissionEditDialog"
      @close="showCommissionEditDialog = false"
      v-model="editedCommission"
      @input="onSave"
    ></commission-edit-dialog>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import { ListMixin } from "../../../../mixins/ListMixin";
import { removeGQLTypename } from "../../../../helpers";
import DefaultListActions from "../../shared/DefaultListActions";
import CommissionEditDialog from "./CommissionEditDialog";
import ListFilters from "../../shared/list-filters/ListFilters";
import listFilters from "./list-filters";
import ListActions from "../../shared/list-actions/ListActions";
const LIST_QUERY = gql`
  query commissions($filter: CommissionFilterType) {
    commissions(filter: $filter) {
      edges {
        node {
          id
          groupId
          agentGroup {
            members {
              edges {
                node {
                  name
                }
              }
            }
          }
          serviceType
          agentGroupName
          department
          commissionPercent
          adultAmount
          childAmount
          notInUse
        }
      }
    }
  }
`;
const UPDATE_MUTATION = gql`
  mutation updateCommission($input: CommissionInput!) {
    updateCommission(input: $input) {
      id
      groupId
      agentGroupName
      commissionAmount
      commissionPercent
      serviceType
      department
      adultAmount
      childAmount
      notInUse
    }
  }
`;
const CREATE_MUTATION = gql`
  mutation createCommission($input: CommissionInput!) {
    createCommission(input: $input) {
      id
      groupId
      agentGroupName
      commissionAmount
      commissionPercent
      serviceType
      department
      adultAmount
      childAmount
      notInUse
    }
  }
`;
const DELETE_MUTATION = gql`
  mutation deleteCommission($id: ID!) {
    deleteCommission(id: $id) {
      id
    }
  }
`;

export default {
  name: "commission-list",

  mixins: [ListMixin],

  components: {
    DefaultListActions,
    CommissionEditDialog,
    ListFilters,
    ListActions
  },

  data() {
    return {
      selected: [],
      debug: false,
      headers: [
        {
          text: "Service Type",
          value: "serviceType",
          name: "serviceType",
        },
        {
          text: "Agent Group",
          value: "agentGroupName",
          name: "agentGroupName",
        },
        {
          text: "Department",
          value: "department",
          name: "department",
        },
        {
          text: "Commission %",
          value: "commissionPercent",
          name: "commissionPercent",
        },
        {
          text: "Adult Amount",
          value: "adultAmount",
          name: "adultAmount",
        },
        {
          text: "Child Amount",
          value: "childAmount",
          name: "childAmount",
        },
        {
          text: "Not In Use",
          value: "notInUse",
          name: "notInUse",
        },
        {
          text: "Actions",
          value: "actions",
          name: "actions",
        },
      ],
      editedCommission: null,
      showCommissionEditDialog: false,
    };
  },

  computed: {
    items() {
      return this.commissions && this.commissions.edges
        ? this.commissions.edges.map(removeGQLTypename)
        : [];
    },
    filters() {
      return listFilters.map((f) => {
        f.props.outlined = this.$store.getters.localSettings("outlinedInputs");
        return f;
      });
    },
  },

  methods: {
    onFiltersChange(filters) {
      this.first = 50;
      this.searchParams = { ...filters };
    },
    onCreateNew() {
      this.editedCommission = null;
      this.showCommissionEditDialog = true;
    },
    onDeleteItem(item) {
      console.log("removing commission", item);
    },
    onEditItem(item) {
      this.editedCommission = { ...item };
      this.showCommissionEditDialog = true;
    },
    async onSave(payload) {
      console.log("saving commission", payload);
      this.showCommissionEditDialog = false;

      const mutation = payload.id ? UPDATE_MUTATION : CREATE_MUTATION;
      try {
        await this.$apollo.mutate({
          mutation: mutation,
          variables: { input: payload },
          refetchQueries: [
            {
              query: LIST_QUERY,
            },
          ],
        });
        this.$store.dispatch("showAppSnackbar", {
          msg: "Commission Saved.",
        });
      } catch (error) {
        console.log(error);
        const errorMsg = error.graphQLErrors.map((e) => e.message).join(", ");
        this.$store.dispatch("showAppSnackbar", {
          msg: errorMsg,
          color: "error",
        });
      }
    },
    async onDeleteItem(payload) {
      try {
        await this.$apollo.mutate({
          mutation: DELETE_MUTATION,
          variables: {
            id: payload.id,
          },
          refetchQueries: [
            {
              query: LIST_QUERY,
            },
          ],
        });
        this.$store.dispatch("showAppSnackbar", {
          msg: "Commission deleted",
        });
      } catch (error) {
        console.log(error);
      }
    },
  },

  apollo: {
    commissions: {
      query: LIST_QUERY,
      variables() {
        return {
          filter: this.searchParams,
        };
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/plugins/commissions/CommissionList.vue